var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconType)?_c('span',{class:_vm.wrapperClass},[_c('a-icon',{class:_vm.iconClasses,attrs:{"type":_vm.iconType}}),(_vm.showLabel)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2):_c('span',{staticClass:"ben-type"},[_vm._v("—")])}
var staticRenderFns = []

export { render, staticRenderFns }